module.exports = __webpack_public_path__ + "img/logotipo-white.5fe0e396.svg";